import React from 'react';
import { Helmet } from 'react-helmet';
import image from './favicon.png'; // Default image for Open Graph


const SEO = ({ title, description, keywords, canonicalUrl, ogImage }) => {
  const siteTitle = title ? `${title} | MaidEaze` : 'MaidEaze - Professional Home Services';
  const siteDescription = description || 'Redefining Comfort with Trusted Home Services. MaidEaze provides professional cleaning and home services.';
  const siteKeywords = keywords || 'home services, cleaning, maid service, house cleaning';
  const siteUrl = canonicalUrl || 'https://maideaze.com';
  const siteImage = ogImage || image;

  return (
    <Helmet>
      <title>{siteTitle}</title>
      <meta name="description" content={siteDescription} />
      <meta name="keywords" content={siteKeywords} />
      
      {/* Canonical URL */}
      <link rel="canonical" href={siteUrl} />
      
      {/* Open Graph / Facebook */}
      <meta property="og:type" content="website" />
      <meta property="og:url" content={siteUrl} />
      <meta property="og:title" content={siteTitle} />
      <meta property="og:description" content={siteDescription} />
      <meta property="og:image" content={siteImage} />
      
      {/* Twitter */}
      <meta property="twitter:card" content="summary_large_image" />
      <meta property="twitter:url" content={siteUrl} />
      <meta property="twitter:title" content={siteTitle} />
      <meta property="twitter:description" content={siteDescription} />
      <meta property="twitter:image" content={siteImage} />
    </Helmet>
  );
};

export default SEO;